import { createAsyncThunk } from "@reduxjs/toolkit";
import { API_URL } from "../../../app/config";
import { axiosApiInstance } from "../../../app/axios";
import { ErrorToast, SuccessToast } from "../../../components/toast/Toasts";
import { INews } from "../newsModel";
import moment from "moment";

export const getAllNews = createAsyncThunk("News/FindAllNews", async () => {
  try {
    const response = await axiosApiInstance.post(
      `${API_URL}/News/FindAllNews`,
      {
        NewsTitle: "",
      }
    );
    return response.data?.Data;
  } catch (error: any) {
    // ErrorToast(error?.response?.data?.Details || "Something went wrong");
    console.error("Error Fetching News:", error);
    return Promise.reject({
      message: error?.response?.data?.Details || "Something went wrong",
    });
  }
});

export const createNews = createAsyncThunk(
  "News/InsertNews",
  async (NewsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/News/InsertNews`,
        NewsData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error creating News:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const updateNews = createAsyncThunk(
  "News/UpdateNews",
  async (NewsData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/News/UpdateNews`,
        NewsData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error updating News :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const deleteNews = createAsyncThunk(
  "News/DeleteNews",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/News/DeleteNews`,
        { ID }
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error deleting News :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getNewsByID = createAsyncThunk(
  "News/FindByIDNews",
  async (ID: number) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/News/FindByIDNews`,
        { ID }
      );
      const result = response.data?.Data as any;
      return {
        ID: result.ID,
        NewsTitle: result.NewsTitle,
        NewsDate: result.NewsDate
          ? moment(result.NewsDate, "DD MMM YYYY").toDate()
          : "",
        ShortDescription: result.ShortDescription,
        LongDescription: result.LongDescription,
        NewsURL: result.NewsURL,
        MetaTitle: result.MetaTitle,
        MetaDescription: result.MetaDescription,
        Status: result?.Status,
        IsActive: result.IsActive ? 1 : 2,
      } as INews;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error fetching News :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const getAllActiveNews = createAsyncThunk(
  "News/FindAllActiveNews",
  async () => {
    try {
      const response = await axiosApiInstance.get(
        `${API_URL}/News/FindAllActiveNews`
      );
      return response.data?.Data;
    } catch (error: any) {
      // ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error Fetching News:", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);

export const ActiveInactiveNews = createAsyncThunk(
  "News/ActiveInActiveNews",
  async (formData: any) => {
    try {
      const response = await axiosApiInstance.post(
        `${API_URL}/News/ActiveInActiveNews`,
        formData
      );
      SuccessToast(response.data?.Details || "Success");
      return response.data;
    } catch (error: any) {
      ErrorToast(error?.response?.data?.Details || "Something went wrong");
      console.error("Error active-inactive News :", error);
      return Promise.reject({
        message: error?.response?.data?.Details || "Something went wrong",
      });
    }
  }
);
